﻿import { DocumentVersionBestPracticeResultOverviewViewModel } from "@common/components/bestPracticeCheckDialog/BestPracticeCheckDialog.types.ts";

export interface IncidentDocumentSaveModel {
    fileName: string | undefined;
    name: string;
    link: string | undefined;
    uploadId?: string;
}

export interface IncidentDocumentRowViewModel {
    incidentLogDocumentId: string;
    fileName: string | undefined;
    name: string;
    link: string | undefined;
    documentId: string;
    dataId: string | undefined;
    created: Date;
    isTooLargeForAi: boolean;
    aiQualityAssuranceResult?: DocumentVersionBestPracticeResultOverviewViewModel;
}

export class IncidentDocument {
    documentId: string;
    fileName: string;
    name: string;
    link: string;

    constructor() {
        this.documentId = "";
        this.fileName = "";
        this.name = "";
        this.link = "";
    }
}

export class IncidentDocumentViewModel {
    name: string | undefined = undefined;

    constructor(name: string | undefined) {
        this.name = name;
    }
}
